import React from "react"
import HomeBlogPostsWrapper from "./shared/homeBlogPostsWrapper/HomeBlogPostsWrapper"
import HomeBlogPostsContent from "./shared/homeBlogPostsContent/HomeBlogPostsContent"
import MainBlogPost from "./shared/mainBlogPost/MainBlogPost"
import SubBlogPost from "./shared/subBlogPost/SubBlogPost"
import SubBlogPostsWrapper from "./shared/subBlogPostsWrapper/SubBlogPostsWrapper"

const HomeBlogPosts = ({ blogs }) => {
  return (
    <HomeBlogPostsWrapper>
      <HomeBlogPostsContent>
        <MainBlogPost mainBlog={blogs[0].node} />
        <SubBlogPostsWrapper>
          <SubBlogPost subBlog={blogs[1].node} />
          <SubBlogPost subBlog={blogs[2].node} />
        </SubBlogPostsWrapper>
      </HomeBlogPostsContent>
    </HomeBlogPostsWrapper>
  )
}

export default HomeBlogPosts
